// Extrait du Dashboard Finance — 5 derniers dossiers avec statut.
// Données : /api/metier/dossiers?limit=5
import { Receipt, Building2, Loader2 } from "lucide-react";
import { Badge } from "../../components/ui/badge";
import { useFinanceFetch } from "./useFinanceFetch";

const STATUT_LABELS = {
  prospect: "Prospect", dossier_cree: "Dossier créé", dossier_depose: "Déposé",
  aides_en_instruction: "Instruction", aides_validees: "Validé",
  avance_payee: "Avance payée", demande_avance: "Demande avance",
  demande_solde: "Demande solde", paye: "Payé", refuse_anah: "Refusé",
};

export default function FinanceRecentDossiersWidget() {
  const { data, loading, error } = useFinanceFetch("/api/metier/dossiers?limit=5");

  if (loading) {
    return (
      <div
        className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error) {
    return (
      <div
        className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Erreur Dossiers récents : {error}
      </div>
    );
  }

  const dossiers = Array.isArray(data) ? data : data?.items || [];

  return (
    <div
      className="rounded-xl p-5 h-full"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="finance-recent-dossiers-widget"
    >
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <Receipt className="w-4 h-4" style={{ color: "#10b981" }} />
        Dossiers récents
      </h3>
      {dossiers.length === 0 ? (
        <div className="text-center py-8" style={{ color: "var(--oh-text-muted)" }}>Aucun dossier</div>
      ) : (
        <div className="space-y-2">
          {dossiers.slice(0, 5).map((d) => (
            <div
              key={d.id || d._id || d.reference || d.référence}
              className="flex items-center gap-3 p-3 rounded-lg"
              style={{ background: "var(--oh-bg-surface)", border: "1px solid transparent" }}
            >
              <div
                className="p-2 rounded-lg"
                style={{ background: "rgba(139,92,246,0.15)" }}
              >
                <Building2 className="w-4 h-4" style={{ color: "#8b5cf6" }} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate" style={{ color: "var(--oh-text)" }}>
                  {d.client_nom || d.reference || d.référence}
                </p>
                <p className="text-xs truncate" style={{ color: "var(--oh-text-muted)" }}>
                  {d.reference || d.référence}
                </p>
              </div>
              <Badge
                className="text-xs"
                style={{ background: "var(--oh-bg-surface)", border: "1px solid var(--oh-border)", color: "var(--oh-text-secondary)" }}
              >
                {STATUT_LABELS[d.statut_global || d.statut] || d.statut || "—"}
              </Badge>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
